const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH || '/'

export const getPropIcon = (propId) => {
  if (!propId) return ''
  return `${PUBLIC_PATH}imgs/props/${propId}.png`
}

/**
 * 优先读 i18n props.{propId}；缺 key 时回退服务端 propName / propId
 */
export const getPropName = (t, prop) => {
  const propId = prop?.propId || prop?.id || ''
  const fallback = prop?.propName || propId || ''
  if (!propId || typeof t !== 'function') return fallback
  const key = `props.${propId}`
  const name = t(key)
  if (!name || name === key) return fallback
  return name
}

export const formatPropText = (t, prop) => {
  const name = getPropName(t, prop)
  const count = Number(prop?.propCount ?? prop?.count ?? 0)
  if (!name) return '—'
  return count > 0 ? `${name}*${count}` : name
}

/**
 * 按空格拆成片段，供 UI 只在空格处换行（避免泰文等按字符断开）
 */
export const splitTextBySpace = (text) => {
  const value = String(text || '')
  if (!value) return []
  return value.split(/(\s+)/).filter((part) => part !== '')
}
